import { Component, ElementRef, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { SettingsService } from '../../../../services/settings.service';
import { ProjectService } from '../../../../services/project.service';
import { RatingService } from '../../../../services/rating.service';
import { teamMoodsViews } from '../team-mood.component';


@Component({
  selector: 'app-team-mood-voting-avg',
  templateUrl: './team-mood-voting-avg.component.html',
  styleUrls: ['./team-mood-voting-avg.component.scss']
  })


export class TeamMoodVotingAvgComponent implements OnInit {
  @ViewChild('divcontainer', { static: true }) private element: ElementRef;
  @Output() navigate = new EventEmitter<teamMoodsViews>();
  languages: string[];
  private event: Subscription[] = [];
  public avgQuestionRatings: any = [];
  public showAvg = false;
  public isLoaded = false;

  constructor(
    private translate: TranslateService,
    private settingsService: SettingsService,
    private projectService: ProjectService,
    private ratingService: RatingService) {
    this.languages = this.translate.getLangs();
  }

  ngOnInit() {
    this.event.push(this.settingsService.getUpdateObservable().subscribe(res => {
      this.setup();
    }));
    this.setup();
    document.getElementById('navigateVotingAvgRight').addEventListener('click', () => {
      this.navigateToSprintAvg();
    });
  }

  setup() {
    this.loadAvgVoting();
    this.event.push(this.ratingService.updateSelectedProps.subscribe(reload => {
      if (reload) {
        this.loadAvgVoting();
      }
    }));
    this.ratingService.voteSettingsChangedObservable.subscribe(() => {
      this.loadAvgVoting();
    });
    this.ratingService.newVoteObservable.subscribe(() => {
      this.loadAvgVoting();
    });
  }

  loadAvgVoting() {
    this.showAvg = false;
    this.isLoaded = false;
    this.ratingService.getAvgSprint(this.settingsService.getProjectName(),
      this.ratingService.getSelectedSprintId(),
      this.ratingService.getSelectedPerson(),
      this.ratingService.getSelectedStartDate(),
      this.ratingService.getSelectedEndDate()).subscribe(val => {
      this.avgQuestionRatings = val;
      this.isLoaded = true;
      if(this.avgQuestionRatings.findIndex(x => x['avg'] > 0) >= 0) {
        this.showAvg = true;
      }
    });
  }
  newVote() {
    this.navigate.emit(teamMoodsViews.voting);
  }

  navigateToSprintAvg() {
    this.navigate.emit(teamMoodsViews.showTimeRange);
  }
}
